/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ElectricusagefeeTankaDto {

    /**
     * 使用量区分コード
     */
    empamtDivcd?: string;
    /**
     * 使用量区分名称
     */
    elecCspDivName?: string;
    /**
     * 使用量下限
     */
    empamtLowerlimit?: number;
    /**
     * 使用量上限
     */
    empamtUpperlimit?: number;
    /**
     * 使用電力量料金単価
     */
    electricusagefeeTanka?: number;
}

